import React from 'react';
import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  success: {
    color: theme.palette.success.main,
    backgroundColor: alpha(theme.palette.success.light, 0.1),
  },
  warning: {
    color: theme.palette.warning.main,
    backgroundColor: alpha(theme.palette.warning.light, 0.1),
  },
  error: {
    color: theme.palette.error.main,
    backgroundColor: alpha(theme.palette.error.light, 0.1),
  },
  info: {
    color: theme.palette.info.main,
    backgroundColor: alpha(theme.palette.info.light, 0.1),
  },
  container: {
    cursor: 'default',
    height: '20px',
    display: 'inline-flex',
    padding: '4px 8px',
    flexGrow: '0',
    fontSize: '0.75rem',
    minWidth: '20px',
    alignItems: 'center',
    flexShrink: '0',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    borderRadius: '2px',
    letterSpacing: '0.5px',
    justifyContent: 'center',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
}));

// COMPONENT
function HighLabelStatus({ status, children, uppercase, className, ...rest }) {
  const { classes, cx } = useStyles();
  return (
    <span
      className={cx(classes.container, classes[status], uppercase && classes.uppercase, className)}
      {...rest}
    >
      {children}
    </span>
  );
}

export default HighLabelStatus;
